<template>
  <div class="defaultEdit">
    <h2>Настройка пользователя</h2>

    <p class="hint">{{ email }}</p>

    <ElemInput
      valueName="password"
      @changeValue="changeValue"
      :valueProp="password"
      label="Пароль"
    />

    <ElemInput
      valueName="name"
      @changeValue="changeValue"
      :valueProp="name"
      label="Имя"
    />

    <ElemInput
      valueName="surname"
      @changeValue="changeValue"
      :valueProp="surname"
      label="Фамилия"
    />

    <ElemInput
      valueName="patronymic"
      @changeValue="changeValue"
      :valueProp="patronymic"
      label="Отчество"
    />

    <ElemInput
      valueName="birthday"
      @changeValue="changeValue"
      :valueProp="birthday"
      type="date"
      label="Дата рождения"
    />

    <button class="addTitleImage" @click="openPickImage = true" type="button">
      Изменить аватар
    </button>

    <img
      v-if="avatar"
      class="avatar"
      :src="baseUrl + 'storage/images/' + avatar"
    />

    <PickGallery
      v-if="openPickImage"
      @close="openPickImage = false"
      @pickImage="pickImage"
    />

    <div class="form-actions">
      <button class="update" type="button" v-on:click="updateUser">
        Обновить
      </button>
    </div>
  </div>
</template>

<script>
import PickGallery from "@/components/gallery/PickGallery";
import ElemInput from "@/components/elements/elemInput";
import users from "@/composables/views/users.ts";
import { useRoute } from "vue-router";

export default {
  setup() {
    const route = useRoute();

    const {
      getUser,
      login,
      updateUser,
      avatar,
      email,
      name,
      surname,
      patronymic,
      birthday,
      baseUrl,
      getUsers,
      models,
      openPickImage,
    } = users(route.params.id);
    return {
      getUser,
      login,
      updateUser,
      avatar,
      email,
      name,
      surname,
      patronymic,
      birthday,
      baseUrl,
      getUsers,
      models,
      openPickImage,
    };
  },
  data() {
    return {};
  },

  components: {
    PickGallery,
    ElemInput,
    // ElemSelect,
  },
  mounted: function () {},
  async created() {
    this.getUser();
  },

  methods: {
    changeValue(valueName, value) {
      this[valueName] = value;
    },
    pickImage(image) {
      this.avatar = image;
      this.openPickImage = false;
    },
  },
};
</script>